import React from 'react';
import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ModalContent } from './content';
export default function AddTeamMemberV2Modal(_ref) {
  let customTrigger = _ref.customTrigger,
    triggerRefresh = _ref.triggerRefresh;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const internalTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '273-add-teammember-v2-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('team_page.add_new_team_member')));
  // NOTE: Add team member

  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: customTrigger !== undefined ? customTrigger : internalTrigger,
    title: t('team_page.add_new_team_member'),
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(ModalContent, {
    triggerRefresh: triggerRefresh
  }));
}